import React, { useState, useEffect } from 'react'
import _, { isEmpty } from 'lodash'

// import React from 'react'
import { Button, Divider, Input } from 'antd'

import styled from 'styled-components'
// import { Divider } from 'antd'
import HealthCard from '../../healthScore/card'
import Information from '../../UI/extraInformation'
import BodyStatus from '../comp/body'
import HideWrap from '../comp/hideWrap'
import RangeBar from '../comp/rangeBar'
import { RangeColors } from '../../../utils/constant'
import ARTrendsMetricsEditor from '../comp/ARTrendsMetricsEditor'
import Trends from '../comp/CardiometabolicTrends'
import { EditPanIcon } from '../../icons'
import { editCardiometabolicTrends } from '../../../api/assessmentReview'
import { TrendsDateRanges } from '../../trends/wrapper'
import { BlankContainer, DatePickerBlank } from '../../trends'
import moment from 'moment'
import ConditionalHideWrap from './ConditionalHidewrap'
import LowlevelMetrics from './LowleveMetrics'
import { formatDisplayName, getRangeByAgeAndGender } from './LowLevelMetricsHelpers'
import { getBiomarkerById, getRangeAgeScopes } from '../../../api'
import { getMetricById } from '../../../api'
import { IGNORED_METRICS_FOR_LIFESTYLE_RECOMMENDATIONS } from '../../../utils/constant'

export const Container = styled.section`
  .ant-divider-horizontal {
    margin: 32px 0;
  }
  .tags {
    font-size: 12px;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    color: #5a657c;
    display: flex;
    justify-content: flex-end;
    margin-top: -47px;
    padding-bottom: 22px;
    span {
      padding: 4px 20px;
      border: 1px solid rgba(33, 57, 89, 0.2);
      border-radius: 19px;
      margin-left: 16px;
    }
    span:before {
      content: '';
      display: inline-block;
      width: 10px;
      height: 10px;
      border-radius: 10px;
      margin-right: 6px;
    }
    span:first-child:before {
      background: #7fb800;
    }
    span:last-child:before {
      background: #0d2350;
    }
  }
  .range-list {
    display: flex;
    list-style: none;
    font-size: 12px;
    letter-spacing: 0.5px;
    text-transform: uppercase;
    color: rgba(50, 58, 70, 0.5);
    margin: 0;
    li {
      padding-left: 24px;
    }
    span {
      display: inline-block;
      width: 10px;
      height: 10px;
      margin-right: 5px;
    }
  }
  .health-data {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 30px 30px 40px;
    .label {
      white-space: pre-line;
      font-size: 15px;
    }
    .value {
      display: flex;
      align-items: center;
      font-size: 16px;
      color: #4c6072;
      .valid {
        font-size: 12px;
        color: red;
      }
      input {
        background: #edf0f4;
        border-radius: 4px;
        text-align: right;
      }
      span {
        width: 60px;
        display: inline-block;
        margin-right: 20px;
        text-align: right;
      }
    }
  }
  .health-data:nth-child(2n) {
    background: rgba(241, 243, 245, 0.3);
  }
  .body-systems {
    margin-top: 40px;
  }
  .header-name{
    margin-bottom: 30px !important;
  }  

  .trends-container {
    margin-top: 50px;
    button:first-child {
      text-align: center;
    }
  }
`

const ranges = [
  {
    name: 'at risk',
    color: RangeColors.red //'#EA4D00'
  },
  {
    name: 'concern',
    color: RangeColors.orange //'#FF9548'
  },
  {
    name: 'needs monitoring',
    color: RangeColors.yellow //'#FFB800'
  },
  {
    name: 'optimized',
    color: RangeColors.green //'#40C47C'
  }
]

export default function Cardiometabolic(props) {
  const {
    hideSectionHandle,
    hideSection,
    previous,
    latest,
    dynamicData,
    view,
    handleSave,
    loginRole,
    handleCommendSave,
    save,
    onScoreChangeHandle,
    cancelEdit,
    person,
    updateEditingCount,
    id,
    trendMetrics,
    arDetail: { notes, status, detail }
  } = props
  const [valueResults, setValueResults] = useState([])

  useEffect(() => {
    fetchBodyCompMetricsDetails()
  }, [])

  const fetchBodyCompMetricsDetails = async () => {
    const subMetricsWithSections = _.flatMap(
      dynamicData.overviewBodySystems,
      (system) =>
        system.sub_metrics
          ? system.sub_metrics.map((subMetric) => ({
              ...subMetric,
              sectionName: system.display_name
            }))
          : []
    )
    const filteredMetrics = _.uniqBy(
      subMetricsWithSections.filter(
        (metric) =>
          (metric.color === 'orange' || metric.color === 'yellow' || metric.color === 'red') &&
          !IGNORED_METRICS_FOR_LIFESTYLE_RECOMMENDATIONS.includes(metric.display_name)
      ),
      'metricId'
    )

    const ageScopes = (await getRangeAgeScopes()).age_scope

    const biomarkerDetailsPromises = filteredMetrics.map(async (metric) => {
      if (metric.metricId) {
        const biomarkerDetail = await getBiomarkerById(metric.metricId)

        const conventionalRanges = getRangeByAgeAndGender(
          biomarkerDetail.conventional_ranges,
          person,
          ageScopes
        )

        const introduction =
          biomarkerDetail && biomarkerDetail.introduction
            ? biomarkerDetail.introduction
            : 'No introduction available'
        return {
          displayName: formatDisplayName(metric.display_name),
          value: metric.value,
          color: metric.color,
          level: metric.level,
          biomarkerDetail,
          introduction,
          sectionName: metric.sectionName,
          conventionalRanges
        }
      }
      return null
    })

    const results = await Promise.all(biomarkerDetailsPromises)
    setValueResults(results.filter((result) => result !== null))
  }

  const data = {
    name: 'Cardiometabolic',
    type: 'cardiometabolic',
    description:
      'Your score emcompasses the health of your heart, blood vessels, and metabolism. It considers your risk for developing heart disease and Type 2 diabetes, two prevalent chronic diseases.',
    ...latest.snapshot.cardiometabolic
  }

  const compare = {
    name: 'Cardiometabolic',
    type: 'cardiometabolic',
    description:
      'Your score emcompasses the health of your heart, blood vessels, and metabolism. It considers your risk for developing heart disease and Type 2 diabetes, two prevalent chronic diseases.',
    ...previous.snapshot.cardiometabolic
  }

  const [validScore, setValidScore] = useState(true)
  const [scoreEditing, setScoreEditing] = useState(
    status !== 1 && !(detail && detail.ASCVD) && view !== 'Preview'
  )
  const [metsScoreEditing, setMetsScoreEditing] = useState(
    status !== 1 &&
      !(detail && _.isNumber(detail.mets_score)) &&
      view !== 'Preview'
  )
  const [trendsEditing, setTrendsEditing] = useState(false)
  const [selectedTrendsMetrics, setSelectedTrendsMetrics] = useState(() => {
    const storedMetrics = _.get(dynamicData, 'trends.trends_metric_keys') || []
    if (storedMetrics.length > 0) {
      const allMetrics = _.flattenDeep(
        recursiveFn(trendMetrics[0].children, (e) => e)
      )
      return storedMetrics.map((original) => {
        const target = allMetrics.filter(
          (item) => item.metric_key === original.metric_key
        )[0]
        return _.assignIn({ ...original }, target, {
          add_metrics: [],
          categories: ['Blood Metrics']
        })
      })
    }
    return null
  })

  // const metsScore =
  //   dynamicData.mets_z_wc || dynamicData.mets_z_bmi || dynamicData.metsScore
  function getCalculateScore() {
    const percent =
      detail &&
      detail.mets_score &&
      100 *
        (1 /
          (1 +
            Math.exp(
              -0.07056 * Math.pow(detail.mets_score, 3) -
                1.5976 * detail.mets_score
            )))
    // dynamicData.mets_z_wc
    //   ? dynamicData.metsPercent
    //   : dynamicData.metBMIPercent
    if (
      _.isFinite(percent) &&
      dynamicData.lipidScore &&
      detail &&
      detail.ASCVD
    ) {
      return Math.round(
        0.2 * detail.ASCVD +
          0.4 * (100 - percent) +
          0.4 * dynamicData.lipidScore
      )
    } else {
      return '--'
    }
  }

  const healthData = [
    {
      label: `Atherosclerotic & Cardiovascular
        Disease Score`,
      value: detail && detail.ASCVD,
      ranges: {
        at_risk: [-Number.MAX_VALUE, 80],
        concern: [80, 90],
        needs_monitoring: [90, 95],
        optimized: [95, Number.MAX_VALUE]
      },
      inputValue: scoreEditing ? (
        <>
          <Input
            placeholder={detail && detail.ASCVD}
            defaultValue={detail ? detail.ASCVD : null}
            autoFocus={true}
            onKeyUp={(e) => {
              const ASCVD = Number(e.target.value)
              setValidScore(true)
              if (!ASCVD || ASCVD > 100) {
                setValidScore(false)
              } else if (e.keyCode === 13) {
                handleSave({ detail: { ASCVD } })
                setScoreEditing(false)
                detail.ASCVD = ASCVD
              }
            }}
          />
          {!validScore && <span className="valid">Invalid</span>}
        </>
      ) : (
        <span
          onClick={() =>
            status !== 1 && view !== 'Preview' && setScoreEditing(true)
          }
        >
          {(detail && detail.ASCVD) || '--'}
        </span>
      )
    },
    {
      label: 'Metabolic Syndrome Severity Score',
      value: detail && detail.mets_score, //_.isFinite(metsScore) ? Math.round(metsScore * 100) / 100 : '--',
      ranges: {
        at_risk: {
          range: [1, Number.MAX_VALUE],
          label: '+1 or higher'
        },
        concern: {
          range: [0, 1],
          label: '0 to +1'
        },
        needs_monitoring: {
          range: [-1, 0],
          label: '0 to -1'
        },
        optimized: {
          range: [-Number.MAX_VALUE, -1],
          label: '-1 or lower'
        }
      },
      inputValue: metsScoreEditing ? (
        <>
          <Input
            placeholder={detail && detail.mets_score}
            defaultValue={detail ? detail.mets_score : null}
            autoFocus={true}
            onKeyUp={(e) => {
              const mets_score = Number(e.target.value)
              // setValidScore(true)
              // if (!ASCVD || ASCVD > 100) {
              //   setValidScore(false)
              // } else
              if (e.keyCode === 13) {
                handleSave({ detail: { mets_score } })
                setMetsScoreEditing(false)
                detail.mets_score = mets_score
              }
            }}
          />
          {/* {!validScore && <span className="valid">Invalid</span>} */}
        </>
      ) : (
        <span
          onClick={() =>
            status !== 1 && view !== 'Preview' && setMetsScoreEditing(true)
          }
        >
          {detail && _.isNumber(detail.mets_score) ? detail.mets_score : '--'}
        </span>
      )
    },
    {
      label: 'Apeiron Advanced Lipid Score',
      value: dynamicData.lipidScore || '--',
      ranges: {
        at_risk: [-Number.MAX_VALUE, 80],
        concern: [80, 90],
        needs_monitoring: [90, 95],
        optimized: [95, Number.MAX_VALUE]
      }
    },
    {
      label: 'Apeiron Total Cardiometabolic Score',
      value: getCalculateScore(),
      ranges: {
        at_risk: [-Number.MAX_VALUE, 80],
        concern: [80, 90],
        needs_monitoring: [90, 95],
        optimized: [95, Number.MAX_VALUE]
      }
    }
  ]

  const cardio = notes.find((item) => item.pillar === 'cardio')
  const body = notes.find((item) => item.pillar === 'body')
  const cardioLevel = getScore(
    data.score_manual ? data.score_manual.value : data.score_auto
  )
  return (
    <ConditionalHideWrap
      id={id}
      name="Body Systems"
      isSection={true}
      syncStatus={hideSectionHandle}
      status={hideSection}
      view={view}
      condition={
        view === 'Draft' || (view === 'Preview' && !hideSection.includes('Body Systems'))
      }
    >
      <Container>
        <h1 className="section-title">Body Systems</h1>
          <>
          <ConditionalHideWrap
            name="Cardiometabolic Health - Summary"
            title="Summary"
            syncStatus={hideSectionHandle}
            status={hideSection}
            view={view}
            condition={
              view === 'Draft' || (view === 'Preview' && !hideSection.includes('Cardiometabolic Health - Summary'))
            }
          >
            <div className="sub-title header-name"></div>
            <HealthCard
              {...data}
              compare={compare}
              save={save}
              loginRole={loginRole}
              onChangeHandle={onScoreChangeHandle}
              disEdit={status === 1 || view === 'Preview'}
              cancel={cancelEdit}
            />
            <Divider />
          </ConditionalHideWrap>
          </>
        {!dynamicData.ui_version && (
          <>
            <ConditionalHideWrap
              name="Cardiometabolic Health - Cardiovascular And Metabolic Health"
              title="Cardiovascular And Metabolic Health"
              syncStatus={hideSectionHandle}
              status={hideSection}
              view={view}
              condition={
                view === 'Draft' || (view === 'Preview' && !hideSection.includes('Cardiometabolic Health - Cardiovascular And Metabolic Health'))
              }
            >
              <div className="sub-title">
                <span>Cardiovascular and Metabolic Health</span>
              </div>
              <div className="sub-title">
                <span></span>
                <ul className="range-list">
                  {ranges.map((item, index) => (
                    <li key={index}>
                      <span style={{ background: item.color }} /> {item.name}
                    </li>
                  ))}
                </ul>
              </div>
              <div className="health-data-container">
                {healthData.map((item, index) => (
                  <div key={index} className="health-data">
                    <div className="label">{item.label}</div>
                    <div className="value">
                      <span>{item.inputValue || item.value}</span>
                      <RangeBar ranges={ranges} data={item} />
                    </div>
                  </div>
                ))}
              </div>
              <Divider />
            </ConditionalHideWrap> 
          </>
        )}
        <ConditionalHideWrap
            name="Cardiometabolic Health - Health Risk Body Systems"
            title="Health Risk Body Systems"
            syncStatus={hideSectionHandle}
            status={hideSection}
            view={view}
            condition={
              view === 'Draft' || (view === 'Preview' && !hideSection.includes('Cardiometabolic Health - Health Risk Body Systems'))
            }
        >
            <div className="sub-title header-name"></div>
            <Information
              title="COMMENT/NOTE"
              disMarkDone={true}
              status={view === 'Draft' ? 'Draft' : 'Opened'}
              initialValue={body ? body.memo : ''}
              updateCommend={(value) => handleCommendSave(value, 'body')}
              updateEditingCount={updateEditingCount}
            />
            <div className="body-systems">
              <BodyStatus
                data={dynamicData.overviewBodySystems}
                cardioLevel={cardioLevel}
                person={person}
              />
            </div>
        </ConditionalHideWrap> 
        <div className="trends-container">
          <div
            style={{
              textAlign: 'center'
            }}
          >
            {view === 'Draft' ? (
              <Button
                type="primary"
                ghost
                onClick={() => setTrendsEditing(true)}
              >
                {selectedTrendsMetrics && selectedTrendsMetrics.length > 0 ? (
                  <EditPanIcon />
                ) : (
                  '+'
                )}{' '}
                {selectedTrendsMetrics && selectedTrendsMetrics.length > 0
                  ? 'EDIT'
                  : 'ADD'}{' '}
                TRENDS
              </Button>
            ) : (
              renderRange(dynamicData.trends)
            )}
          </div>
          {selectedTrendsMetrics && selectedTrendsMetrics.length > 0 && (
            <Trends
              storedData={
                isEmpty(dynamicData.trends) ? null : dynamicData.trends
              }
              metrics={selectedTrendsMetrics}
              person={person}
              view={view}
              storeCallback={(state, metrics) => {
                const params = {
                  trends_metric_keys: metrics.map((e) => e.metric_key),
                  from: state.from,
                  to: state.to,
                  rangeType: TrendsDateRanges[state.selectedDate].type,
                  show_graph_type: state.showGraphType,
                  show_number: state.showNumber,
                  range_type_index: state.selectedDate
                }
                editTrends(params)
              }}
            />
          )}
        </div>
        {trendsEditing && (
          <ARTrendsMetricsEditor
            allMetrics={trendMetrics}
            selectedMetrics={selectedTrendsMetrics}
            onCancel={() => setTrendsEditing(false)}
            apply={(metrics) => {
              setSelectedTrendsMetrics([...metrics])
            }}
          />
        )}
        <LowlevelMetrics metricValues={valueResults} view={view} hideSection={hideSection} hideSectionHandle={hideSectionHandle} />
      </Container>
    </ConditionalHideWrap>
  )

  function renderRange(trends) {
    if (isEmpty(trends)) {
      return null
    }
    const range = TrendsDateRanges[trends.range_type_index || 0]
    switch (range.picker) {
      case 'blank':
        return <DatePickerBlank dateRange={range} />
      case 'year':
        return <BlankContainer>Annual {trends.from.slice(0, 4)}</BlankContainer>
      default:
        if (range.type === 'lifetime') {
          return <BlankContainer>Lifetime</BlankContainer>
        } else {
          return (
            <BlankContainer>
              {moment(range.from).format('YYYY-MM-DD')} -{' '}
              {moment(range.to).format('YYYY-MM-DD')}
            </BlankContainer>
          )
        }
    }
  }

  async function editTrends(params) {
    await editCardiometabolicTrends(props.arDetail.id, params)
  }

  function recursiveFn(children, returnBlock) {
    return children.map((child) => {
      if (child.children) {
        return recursiveFn(child.children, returnBlock)
      } else {
        return returnBlock(child)
      }
    })
  }
}

function getScore(score) {
  let status
  if (!score && score !== 0) {
    status = null
  } else if (score < 80) {
    status = 'At risk'
  } else if (score >= 80 && score < 90) {
    status = 'Concern'
  } else if (score >= 90 && score < 95) {
    status = 'Needs Monitoring'
  } else if (score >= 95) {
    status = 'Optimal'
  }
  return status
}
